import React, { useEffect, useState } from "react";
import { usd, jmdOnly, setFxRate } from "@/lib/money";
import { api } from "@/lib/api";

// Loads the live J$→US$ rate before first paint so every price (jmd()/usd() callers included) uses the same rate.
export const FxLoader = ({ children }) => {
  const [ready, setReady] = useState(false);
  useEffect(() => { api.get("/fx").then(({ data }) => { setFxRate(data?.rates?.USD); window.dispatchEvent(new Event("fx-ready")); }).catch(() => {}).finally(() => setReady(true)); }, []);
  return ready ? children || null : null;
};

// US$ main price with the J$ amount underneath — the single customer-facing price presentation.
export const Price = ({ amount, className = "", size = "md", strike = false, testid }) => {
  const [, tick] = useState(0);
  useEffect(() => { const h = () => tick((n) => n + 1); window.addEventListener("fx-ready", h); return () => window.removeEventListener("fx-ready", h); }, []);
  const main = { sm: "text-sm", md: "text-lg", lg: "text-4xl" }[size] || "text-lg";
  return (
    <span className={`inline-flex flex-col leading-tight ${className}`} data-testid={testid}>
      <span className={`font-display font-extrabold text-ink ${main} ${strike ? "line-through text-muted-foreground font-semibold" : ""}`}>{usd(amount)}</span>
      <span className={`text-[11px] text-muted-foreground ${strike ? "line-through" : ""}`}>{jmdOnly(amount)}</span>
    </span>
  );
};
